import { render, staticRenderFns } from "./winner-card.vue?vue&type=template&id=34a015d0&scoped=true&"
import script from "./winner-card.vue?vue&type=script&lang=js&"
export * from "./winner-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a015d0",
  null
  
)

export default component.exports